<template>
  <div class="select cursor" @click="showOptions = true">
    {{options[lastGrade]}}
    <div :class="[!showOptions ? 'arrow' : 'arrow_up']"></div>
    <div class="options" v-show="showOptions" @mouseleave="showOptions = false">
      <div 
        class="select-option" 
        v-for="i in list" :key="i"  
        :class="{'active':lastGrade==i}" 
        @click.stop="handleChange(i)">{{options[i]}}</div>
    </div>
  </div>
</template>
<script>
import { mapState,mapMutations } from "vuex";
export default {
  data() {
    return {
      options:{
        1:"一年级+",
        2:"二年级+",
        3:"三年级+",
        4:"四年级+",
        5:"五年级+",
        6:"六年级+",
        7:"七年级+",
        8:"八年级+",
        9:"九年级+"
      },
      showOptions: false
    }
  },
  props:{
    list:{
      type:Array,
      required:true,
    }
  },
  computed: {
    ...mapState(['lastGrade'])
  },
  methods: {
    ...mapMutations(['setLastGrade']),
    handleChange(item) {
      this.showOptions = false
      this.setLastGrade(item*1)
    }
  }
}
</script>
<style lang="less" scoped>
.select{
  position: relative;
  width: 100%;
  height: 100%;
  font-weight: 600;
  line-height: 54px;
  font-size: 22px;
  color: #0073ae;
  text-align: left;
  padding-left: 24px;
  .arrow{
    position: absolute;
    top: 20px;
    right: 20px;
    width: 16px;
    height: 16px;
    background:  url("../../../assets/img/common/arrow_down.png") no-repeat;
    background-size: cover;
  }
  .arrow_up{
    position: absolute;
    top: 20px;
    right: 20px;
    width: 16px;
    height: 16px;
    background:  url("../../../assets/img/common/arrow_up.png") no-repeat;
    background-size: cover;
  }
  .options{
    position: absolute;
    display: flex;
    flex-direction: column;
    padding: 0 23px;
    top: 60px;
    left: 0;
    border-radius: 23px;
    text-align: center;
    width: 100%;
    background: rgba(0,115,174, .8);
    .select-option{
      color: #fff;
      height: 57px;
      line-height: 57px;
      border-bottom: 1px solid rgba(255,255,255, .16);
    }
    .select-option:hover{
      color: rgba(255,255,255, .5)
    }
    .active{
      color: rgba(255,255,255, .5)
    }
    .select-option:last-child{
      border: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/bussiness/game/tool.vue